export default __webpack_public_path__ + "static/media/title_ko_sp.f53eef13.png";